import React from 'react';
import { motion } from 'framer-motion';
import { MdOutlineDoneAll, MdAttachMoney, MdShield, MdTimeline } from 'react-icons/md';
import { HiLightningBolt } from 'react-icons/hi';
import './Trust.css';

// Using existing assets for the staggered images
import roofer1 from '../../assets/images/welcome-01.jpg';
import roofer2 from '../../assets/images/welcome-02.jpg';

function Trust() {
  const features = [
    {
      id: 1,
      icon: <MdOutlineDoneAll />,
      title: 'Easy Process',
      desc: 'Our team is committed to using the highest standard.'
    },
    {
      id: 2,
      icon: <MdAttachMoney />,
      title: 'Save Money',
      desc: "We're here to make your roofing project affordable."
    },
    {
      id: 3,
      icon: <MdShield />,
      title: 'High Security',
      desc: 'Our dedicated team works closely with you.'
    }
  ];

  return (
    <section className="why-us" id="WhyUs">
      <div className="container">
        <div className="why-us__inner">

          {/* ── Left Content ───────────────────────────────── */}
          <div className="why-us__content">
            <motion.div
              className="section-label"
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <HiLightningBolt style={{ fontSize: '14px' }} />
              Why Choose Us
            </motion.div>

            <motion.h2
              className="why-us__title"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              Your Trusted Partner in <br /> <span>Roofing Excellence</span>
            </motion.h2>

            <motion.p
              className="why-us__desc"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              Choosing the right roofing company is essential for protecting
              your home and ensuring peace of mind. At CIK, we combine years of
              experience, exceptional craftsmanship, and unmatched dedication.
            </motion.p>

            <div className="why-us__features-grid">
              {features.map((item, idx) => (
                <motion.div
                  key={item.id}
                  className="why-us__feature-card"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.3 + (idx * 0.15) }}
                >
                  <div className="why-us__feature-icon">
                    {item.icon}
                  </div>
                  <h4 className="why-us__feature-title">{item.title}</h4>
                  <p className="why-us__feature-text">{item.desc}</p>
                </motion.div>
              ))}
            </div>
          </div>

          {/* ── Right Media ────────────────────────────────── */}
          <div className="why-us__media">
            <motion.div
              className="why-us__image-staggered why-us__image-staggered--1"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <img src={roofer1} alt="Roofer at work" />
            </motion.div>

            <motion.div
              className="why-us__image-staggered why-us__image-staggered--2"
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              <img src={roofer2} alt="Precise roof repair" />
            </motion.div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Trust;